import ScreenThumb from "@/components/gallery/ScreenThumb";
import { useLightbox } from "@/components/gallery/useLightbox";
import { ALL_SCREENS, SCREEN_GROUPS } from "@/lib/screens";

export default function Screens() {
  const { open, viewer } = useLightbox(ALL_SCREENS);
  return (
    <div data-testid="screens-page" className="mx-auto max-w-7xl px-5 pb-24 pt-32 md:px-10 md:pt-40">
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#CAA362]">Schermen</p>
      <h1 className="font-serif-display text-4xl font-semibold text-[#EAEBE7] sm:text-5xl">Waidbook in beeld</h1>
      <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#B5B8B0]">
        Voorbeeldschermen uit de Waidbook-app met geanonimiseerde gegevens. Weer-, datum- en
        statusinformatie in de beelden is een momentopname, geen live weergave. Schermen met het
        label Testversie tonen functies uit de nieuwste testversie van de app.
      </p>

      <nav aria-label="Groepen" className="mt-10 flex flex-wrap gap-2">
        {SCREEN_GROUPS.map((g) => (
          <a
            key={g.id}
            href={`#groep-${g.id}`}
            data-testid={`group-link-${g.id}`}
            className="rounded-xl border border-[#2C2E29] bg-[#1C1D1A] px-4 py-2 text-sm text-[#B5B8B0] transition-colors hover:border-[#CAA362]/50 hover:text-[#E0BE82]"
          >
            {g.title}
          </a>
        ))}
      </nav>

      {SCREEN_GROUPS.map((g) => (
        <section key={g.id} id={`groep-${g.id}`} data-testid={`group-${g.id}`} className="scroll-mt-28 border-t border-[#2C2E29] pt-12 mt-14">
          <h2 className="mb-8 font-serif-display text-2xl font-semibold text-[#EAEBE7]">
            {g.title} <span className="ml-1 text-base font-normal text-[#8E9189]">{g.screens.length}</span>
          </h2>
          <div className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-6">
            {g.screens.map((s) => (
              <ScreenThumb key={s.n} screen={s} testid={`screen-thumb-${s.n}`} onOpen={() => open(s.n - 1)} />
            ))}
          </div>
        </section>
      ))}
      {viewer}
    </div>
  );
}
